import { doc } from 'config/environment';
import { applyCSS } from 'src/global/css';
import hooks from 'src/events/Hook';
import { getElement } from 'utils/dom';
import runloop from 'src/global/runloop';
import { createFragment } from './initialise';

export default function render(blcktive, target, anchor, occupants) {
  // set a flag to let any transitions know that this instance is currently rendering
  blcktive.rendering = true;

  const promise = runloop.start();
  runloop.scheduleTask(() => hooks.render.fire(blcktive), true);

  if (blcktive.fragment.rendered) {
    throw new Error(
      'You cannot call blcktive.render() on an already rendered instance! Call blcktive.unrender() first'
    );
  }

  if (blcktive.destroyed) {
    blcktive.destroyed = false;
    blcktive.fragment = createFragment(blcktive).bind(blcktive.viewmodel);
  }

  anchor = getElement(anchor) || blcktive.anchor;

  blcktive.el = blcktive.target = target;
  blcktive.anchor = anchor;

  // ensure encapsulated CSS is up-to-date
  if (blcktive.cssId) applyCSS();

  if (target) {
    (target.__blcktive_instances__ || (target.__blcktive_instances__ = [])).push(blcktive);

    if (anchor) {
      const docFrag = doc.createDocumentFragment();
      blcktive.fragment.render(docFrag);
      target.insertBefore(docFrag, anchor);
    } else {
      blcktive.fragment.render(target, occupants);
    }
  }

  runloop.end();
  blcktive.rendering = false;

  return promise.then(() => {
    if (blcktive.torndown) return;

    hooks.complete.fire(blcktive);
  });
}
